import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMinusMedium"><Path d="M5 12H19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMinusMedium;
